// Handles import form conditional field visibility
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operation"]

  connect() {
    this.updateOptions()
  }

  // Show/hide fields based on checked operation checkboxes
  updateOptions() {
    // Hide all optional fields by default
    $('.options').closest('.table-elem').hide();
    $('.options').closest('.form-row').hide();

    // For each operation checkbox, show/hide relevant fields
    this.operationTargets.forEach((checkbox) => {
      const opName = checkbox.dataset.operation;
      console.log('Processing checkbox:', opName, 'checked:', checkbox.checked);

      if (checkbox.checked) {
        // Show fields with this operation class
        $('.' + opName).closest('.form-row').show();
        $('.' + opName).closest('.table-elem').show();
        // Hide fields with not- prefix (inverse logic)
        $('.not-' + opName).closest('.form-row').hide();
        $('.not-' + opName).closest('.table-elem').hide();
      } else {
        // When unchecked, show fields with not- prefix
        $('.not-' + opName).closest('.form-row').show();
        $('.not-' + opName).closest('.table-elem').show();
      }
    });
  }

  // Handle checkbox changes with mutual exclusivity for matches/circles
  handleOperationChange(event) {
    const checkbox = event.currentTarget;
    const operation = checkbox.dataset.operation;

    console.log('Checkbox changed:', operation, 'checked:', checkbox.checked);

    // Matches and circles are mutually exclusive
    if (operation === 'matches' && checkbox.checked) {
      const circlesCheckbox = this.operationTargets.find(t => t.dataset.operation === 'circles');
      if (circlesCheckbox?.checked) {
        circlesCheckbox.checked = false;
      }
    } else if (operation === 'circles' && checkbox.checked) {
      const matchesCheckbox = this.operationTargets.find(t => t.dataset.operation === 'matches');
      if (matchesCheckbox?.checked) {
        matchesCheckbox.checked = false;
      }
    }

    this.updateOptions();
  }
}